<template>
    <div class="card p-3 ">
        <slot></slot>
    </div>
</template>